import React, { useState, useEffect } from 'react'
import { useNavigate, useSearchParams } from "react-router-dom";
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import ArrowBackIosNewSharpIcon from '@mui/icons-material/ArrowBackIosNewSharp';
import { visuallyHidden } from '@mui/utils';
import Divider from '@mui/material/Divider';
import { createNotification } from '../../../Config/NotificationToast';
import styled from '@emotion/styled';
import Select from "react-select";
import { FormGroup, Label, } from "reactstrap";
import { deleteGuest, viewGuestUsers, } from '../../../redux/actions/UserManagementAction/GuestUserAction/GuestUserAction';
import { updateIsActiveStatus } from '../../../redux/actions/MasterDataAction/ProgramAction/programActions';
import * as routes from "../../../Router/RoutesURL";
import {
    stableSort,
    getComparator,
    rowOptions,
    options,
    getPermissionByAppName,
} from '../../../utils/Helper'
import { useSelector, useDispatch } from 'react-redux';
import './Downloads.scss';
import { CircularProgress } from '@mui/material';
import Delete from "../../../assets/images/CommonComponent/trash.svg";
import { Modal } from 'react-bootstrap';
import { guestType, tabKeys } from '../../../Config/Constant';
import moment from 'moment';

const MainHeading = styled(Typography)(({ theme }) => ({
    color: theme.palette.primary.main,
}))


const headCells = [
    {
        id: 'first_name',
        disablePadding: true,
        label: 'FIRST NAME',
    },
    {
        id: 'last_name',
        disablePadding: false,
        label: 'LAST NAME',
    },
    {
        id: 'phone_number',
        disablePadding: false,
        label: 'MOBILE NO.',
    },
    {
        id: 'email_id',
        disablePadding: false,
        label: 'EMAIL ADDRESS',
    },
    {
        id: 'is_active',
        disablePadding: false,
        label: 'LAST LOGIN',
    },
    {
        id: 'action',
        disablePadding: false,
        label: 'ACTION',
        disableSorting: true

    },
];

const EnhancedTableHead=(props)=> {
    const { order, orderBy, onRequestSort } =
        props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                {headCells.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        align='left'
                        padding={headCell.disablePadding ? 'none' : 'normal'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                            hideSortIcon={headCell.disableSorting}
                            disabled={headCell.disableSorting}
                        >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                                <Box component="span" sx={visuallyHidden}>
                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </Box>
                            ) : null}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
};

const EnhancedTableToolbar=(props)=> {
    const { setShowLoader, activeTab } = props;
    const [searchParams, setSearchParams] = useSearchParams();
    const dispatch = useDispatch();
    const [searchText, setSearchText] = useState(searchParams.get('filter_text') || '');

    useEffect(() => {
        if (activeTab == tabKeys.userManagement.DOWNLOADS) {
            setSearchText(searchParams.get('filter_text') || '');
        }
    }, [activeTab, searchParams]);
    

    const handleChangeSearch = (e) => {
        setShowLoader(true)
        const newSearchText = e.target.value;
        setSearchText(newSearchText);

        const newParams = new URLSearchParams(searchParams);
        if (newSearchText) {
            newParams.set('filter_text', newSearchText);
        } else {
            newParams.delete('filter_text');
        }
        newParams.set('page', '1');
        setSearchParams(newParams, { replace: true });
    }

    return (

        <div>
            <Toolbar sx={{
                pl: { sm: 2 },
                pt: { sm: 2 },
                pb: { sm: 2 },
                pr: { xs: 1, sm: 1 }
            }}
            >
                <div className='col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-3'>
                    <MainHeading
                        sx={{ flex: '1 1 100%', }}
                        variant="h6"
                        id="tableTitle"
                        component="div"
                    >
                        Downloads
                    </MainHeading>
                </div>
                <div className='col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 col-xxl-9 p-0 GuestUserLevelDiv'>
                    <div className="mr-sm-2 searchDiv class-search ">
                        <input
                            value={searchText}
                            className="form-control mr-sm-2 class-search"
                            type="search"
                            placeholder=" Search Keyword"
                            aria-label="Search"
                            onChange={handleChangeSearch}
                        ></input>
                    </div>
                </div>
            </Toolbar>
            <Divider />
        </div>
    );
}

EnhancedTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired,
};

const Downloads = (props) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [order, setOrder] = useState(searchParams.get('order_dir') || '');
    const [orderBy, setOrderBy] = useState(searchParams.get('order_by') || '');
    const [selected, setSelected] = useState([]);
    const [page, setPage] = useState(parseInt(searchParams.get('page')) || 1);
    const [rowsPerPage, setRowsPerPage] = useState(parseInt(searchParams.get('page_size')) || 10);
    const [viewGuestListMainData, setViewGuestListMainData] = useState('');
    const [showNext, setShowNext] = useState(false);
    const [showPrev, setShowPrev] = useState(false);
    const [showLoader, setShowLoader] = useState(false);
    const navigate = useNavigate()
    const { loading } = useSelector(state => state.viewGuestUsers);
    const viewGuestListDat = useSelector(state => state.viewGuestUsers);
    const viewGuestListDataRes = useSelector(state => state.viewGuestUsers.allGuestsList);
    const btnPrev = ["btnPrev", showPrev ? "" : "opacityBtns"]
    const btnNext = ["btnNext", showNext ? "" : "opacityBtns"]
    const dispatch = useDispatch();
    const { permission, activeTab } = props;
    const [showConfirm, setShowConfirm] = useState(false);
    const [id, setId] = useState('');

    useEffect(() => {
        if (activeTab == tabKeys.userManagement.DOWNLOADS) {
            const orderDir = searchParams.get('order_dir') || '';
            const orderByCol = searchParams.get('order_by') || '';
            let sendRequest = {
                "page_no": searchParams.get('page') || 1,
                "page_size": searchParams.get('page_size') || 10,
                'filter_text': searchParams.get('filter_text') || '',
                "order_by": orderByCol,
                "order_dir": orderDir,
                "role_id": "00",
                "type": guestType.ALL
            };
            dispatch(viewGuestUsers(sendRequest));
            setPage(parseInt(searchParams.get('page')) || 1);
            setRowsPerPage(parseInt(searchParams.get('page_size')) || 10);
            setOrder(orderDir);
            setOrderBy(orderByCol);
        }
    }, [activeTab, searchParams]);

    useEffect(() => {
        if (!loading)
            setShowLoader(false)
        if (!loading && !viewGuestListDataRes?.data?.guest_users && !viewGuestListDat.error) {
            setShowLoader(true)
        }
    }, [loading])

    useEffect(() => {
        if (viewGuestListDat.error !== "No data available to show for guests users") {
            setViewGuestListMainData(viewGuestListDataRes && viewGuestListDataRes?.data?.guest_users);
            if (viewGuestListDataRes?.data?.current_page_no === 1) {
                setShowPrev(false)
            } else {
                setShowPrev(true)
            }

            if (viewGuestListDataRes?.data?.current_page_no === viewGuestListDataRes?.data?.total_pages) {
                setShowNext(false)
            } else {
                setShowNext(true)
            }
        } else {
            setViewGuestListMainData("");
        }
    }, [viewGuestListDataRes, viewGuestListDat])

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        const newOrder = isAsc ? 'desc' : 'asc';
        const newParams = new URLSearchParams(searchParams);
        newParams.set('order_by', property);
        newParams.set('order_dir', newOrder);
        setSearchParams(newParams, { replace: true });
    };

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelected = viewGuestListDataRes && viewGuestListDataRes.map((n) => n.name);
            setSelected(newSelected);
            return;
        }
        setSelected([]);
    };

    const handleClick = (event, name) => {
        const selectedIndex = selected.indexOf(name);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, name);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }
        setSelected(newSelected);
    };

    const handleChangePageNext = (newPage) => {
        setShowLoader(true)
        const nextPage = page + 1;
        setPage(nextPage);
        const newParams = new URLSearchParams(searchParams);
        newParams.set('page', nextPage.toString());
        setSearchParams(newParams, { replace: true });
    };
    const handleChangePagePrev = (newPage) => {
        setShowLoader(true)
        const prevPage = page - 1;
        setPage(prevPage);
        const newParams = new URLSearchParams(searchParams);
        newParams.set('page', prevPage.toString());
        setSearchParams(newParams, { replace: true });
    };

    const handleChangeRowsPerPage = (event) => {
        setShowLoader(true)
        const newRowsPerPage = parseInt(event.value, 10);
        setRowsPerPage(newRowsPerPage);
        setPage(1);

        const newParams = new URLSearchParams(searchParams);
        newParams.set('page_size', newRowsPerPage.toString());
        newParams.set('page', '1');
        setSearchParams(newParams, { replace: true });
    };



    const handleChangeViewPro = (selectedUserId, userStatus) => {
        if (userStatus === 1) {
            navigate(routes.DOWNLOAD_VIEW_USER, { state: { selectedUserId, userStatus, permission } })
        }
    };

    const handleDelete = (id) => {
        if (permission === "write") {
            setId(id)
            setShowConfirm(true);
        } else {
            createNotification('warning', "Access Restricted");
        }
    };

    const handleDeleteGuest = () => {
        const sendRequestDelete = {
            id,
            onSuccessCallback: ()=>{
                if(viewGuestListDataRes && viewGuestListDataRes?.data?.start === viewGuestListDataRes?.data?.end){
                    const newParams = new URLSearchParams(searchParams);
                    newParams.set("page", (viewGuestListDataRes?.data?.current_page_no - 1 || 1));
                    setSearchParams(newParams, { replace: true });
                }else{
                    
                    const sendRequest = {
                        "page_no": viewGuestListDataRes?.data?.current_page_no || 1,
                        "page_size": searchParams.get('page_size') || 10,
                        'filter_text': searchParams.get('filter_text') || '',
                        "role_id": "00",
                        "type": guestType.ALL
                    };
                    dispatch(viewGuestUsers(sendRequest));
                }
                setShowConfirm(false);
            }
        };
        dispatch(deleteGuest(sendRequestDelete));
    }

    const cancelWarnModal = () => {
        setShowConfirm(false);
    }

    return (
        <>
            <Box sx={{ width: '100%' }} className="DownloadBox h-100">
              <Paper className='d-flex flex-column' sx={{ width: '100%', mb: 1, borderRadius: 2, height: 'calc(100% - 57px)' }}>
                    <EnhancedTableToolbar setShowLoader={setShowLoader} activeTab={activeTab} />
                    {
                        showLoader ?
                        <div className='w-100 py-5 text-center'>
                            <CircularProgress sx={{'color': '#74613C'}}/>
                        </div>
                        :
                        viewGuestListMainData?.length > 0 ? <TableContainer sx={{ pt: 0, pr: 3, pb: 3, pl: 3, height: '100%' }}>
                            <Table
                                sx={{ minWidth: 750 }}
                                aria-labelledby="tableTitle"
                                size='small'
                            >
                                <EnhancedTableHead
                                    numSelected={selected.length}
                                    order={order}
                                    orderBy={orderBy}
                                    onSelectAllClick={handleSelectAllClick}
                                    onRequestSort={handleRequestSort}
                                    rowCount={viewGuestListDataRes && viewGuestListDataRes?.length}
                                />
                                <TableBody>
                                    {
                                        stableSort(viewGuestListMainData, getComparator(order, orderBy))
                                            .map((row, index) => {
    
                                                const labelId = `enhanced-table-checkbox-${index}`;
                                                return (
                                                    <TableRow hover onClick={(event) => handleClick(event, row.firstName)} role="checkbox"
    
                                                        tabIndex={-1}
                                                        key={row.id}
    
                                                    >
                                                        <TableCell component="th" id={labelId} scope="row" padding="none" sx={{ minWidth: '140px', maxWidth: '140px', wordWrap: 'break-word'}}>{row.first_name}</TableCell>
                                                        <TableCell align="left" sx={{minWidth: '150px', maxWidth: '150px', wordWrap: 'break-word'}}>{row.last_name}</TableCell>
                                                        <TableCell align="left" sx={{minWidth: '155px', maxWidth: '155px' }}>{row.phone_number}</TableCell>
                                                        <TableCell align="left" >{row.email_id}</TableCell>
                                                        <TableCell align="left" sx={{ minWidth: '190px', maxWidth: '190px'}}
    
                                                        >
                                                            {moment(row?.last_login_datetime)?.format("DD MMM, YYYY hh:mm A")}
                                                            {/* <Select
    
                                                                className="react-select"
                                                                classNamePrefix="react-select"
                                                                onChange={(e) => { handleChangeOption(e, row.id) }}
                                                                value={row.is_active === 1 ? { label: "Active", value: "Active" } : { label: "Inactive", value: "Inactive" }}
                                                                options={options}
                                                                isSearchable={false}
                                                                theme={(theme) => ({
                                                                    ...theme,
                                                                    isFocused: "#74613C",
                                                                    colors: {
                                                                        ...theme.colors,
                                                                        primary25: '#F5F5F5',
                                                                        primary: '#f6f4f0',
                                                                    },
                                                                })}
                                                                getOptionLabel={(row) => (
                                                                    <><span className={row.label === "Active" ? "ActiveClass" : "InactiveClass"}>
                                                                        {row.label}
                                                                    </span>
                                                                        {row.status === 1 && (
                                                                            <div
    
                                                                            ></div>
                                                                        )}
                                                                    </>
                                                                )}
                                                            /> */}
                                                        </TableCell>
                                                        <TableCell align="left" className='View'> <ul className="list-group d-flex flex-row">

                                                            {
                                                                getPermissionByAppName("Guest User Management") === "write" &&
                                                                <>
                                                                    {/* <li className={row.is_active == 1 ? 'list-group-item ViewEditClick p-0 ' : "list-group-item ViewEditNotClick p-0"}
                                                                        onClick={() => { handleChangeEditUser(row.id, row.is_active) }}><i className="fa fa-pen mr-1"></i> Edit</li> */}
                                                                    <li className="list-group-item Delete p-0" onClick={() => { handleDelete(row.id) }}><img src={Delete} className="mr-1 mb-1" alt="Avatar" width="14px" height="16px" /> Delete</li>
                                                                </>
                                                            }
    
                                                        </ul></TableCell>
                                                    </TableRow>
                                                );
                                            })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        : <div className='text-center w-100 text-muted mt-3'>No Records</div>
                    }
                </Paper>
                {
                    viewGuestListMainData
                    &&
                    <div className='paginationBlock'>
                        <div className='textData'><p>Items per page: </p></div>
                        <FormGroup className="FormGroup has-float-label rowsSelect class-menu-dropdown ">
                            <Select
                                placeholder={rowsPerPage}
                                className="react-select"
                                classNamePrefix="react-select"
                                value={rowsPerPage}
                                options={rowOptions}
                                isSearchable={false}
                                onChange={handleChangeRowsPerPage}
                                theme={(theme) => ({
                                    ...theme,
                                    colors: {
                                        ...theme.colors,
                                        primary25: '#F5F5F5',
                                        primary: '#74613C',
                                    },
                                })}
                                menuPlacement="top"
                                menuPosition="fixed"
                                styles={{
                                    menu: (base) => ({
                                        ...base,
                                        top: 'auto',
                                        bottom: 0,
                                    }),
                                }}
                            />
                        </FormGroup>
                        {viewGuestListDataRes?.data && <p className='endText'>   {viewGuestListDataRes?.data?.start} - {viewGuestListDataRes?.data?.end} of {viewGuestListDataRes?.data?.total}</p>}
                        <p>
                                                    
                            <button className={`btnPrev ${viewGuestListDataRes?.data?.current_page_no === 1 ? "opacityBtns" : ''}`} disabled={viewGuestListDataRes?.data?.current_page_no === 1} onClick={() => { handleChangePagePrev(page) }}>
                                <ArrowBackIosNewSharpIcon className='iconBtn' />
                            </button> 
                            <button className={`btnPrev ${viewGuestListDataRes?.data?.current_page_no === viewGuestListDataRes?.data?.total_pages ? "opacityBtns" : ''}`} disabled={viewGuestListDataRes?.data?.current_page_no === viewGuestListDataRes?.data?.total_pages} onClick={() => { handleChangePageNext(page) }}>
                                <ArrowForwardIosSharpIcon className='iconBtn' />
                            </button></p>
                    </div>
                }
            </Box>
        
        <Modal centered className="guestUser-modal-warning br-8" show={showConfirm} onHide={() => { setShowConfirm(false) }}>
                <Modal.Header>
                    <div className="modalText-guest pb-4">Are you sure you want to delete this guest account ?</div>
                </Modal.Header>
                <Modal.Body>
                    <div className="">
                        <label htmlFor="exampleFormControlInput1" className="form-label DeleteDesc-guest">
                        This will remove guest's online access to all your wellness programme details, sessions, consultant recommendations and other data.
                        </label>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-success greenButton mr-3" onClick={cancelWarnModal}>
                        Cancel</button>
                    <button type="button" className="btn btn-danger redButton " onClick={handleDeleteGuest}>
                        Delete</button>
                </Modal.Footer>
            </Modal>
        </>
        );
}
export default Downloads;